import { apiPost, apiPut } from '@gat-ship/http-client'
import type {
  GenerateProfileImageUploadTicketRequestParams,
  GenerateProfileImageUploadTicketResponse,
  ProcessProfileImageUploadTicketResponse,
  ProcessProfileImageUploadTicketRequestParams
} from '@gat-ship/types'

export async function generateProfileImageUploadTicketRequest<
  T = {
    commandId: string
    purpose: 'user-profile-image'
    uploaderUserId: string
  }
>(params: GenerateProfileImageUploadTicketRequestParams) {
  return await apiPost<GenerateProfileImageUploadTicketResponse<T>>(
    'upload/profile-image/tickets',
    undefined,
    params.commandId
  )
}

export async function processProfileImageUploadTicketRequest(
  params: ProcessProfileImageUploadTicketRequestParams
) {
  return await apiPut<ProcessProfileImageUploadTicketResponse>(
    `upload/profile-image/tickets/${params.ticketId}/process`,
    undefined,
    params.commandId
  )
}
